import styled from "styled-components";
// Import model page
import LayoutTunnel from "../../layouts/tunnel";

export const StyledHasNoRequiredInfos = styled(LayoutTunnel)``;
